'use strict';
const EMPTY = Object.freeze(new Array(0));
module.exports = function RectSet(params) {
	const readOnly = (array) => {
			return Object.freeze(array.slice(0));
		},
		calcRectangles = () => {
			if (!params) {
				return EMPTY;
			}
			if (params.rectangles) {
				return readOnly(params.rectangles);
			}
			if (params.rectSets) {
				const rectArrays = params.rectSets.map(r => r.rectangles);
				return readOnly(rectArrays.reduce((accumulator, current) => accumulator.concat(current)));
			}
			throw new Error('invalid-args');
		},
		rectangles = calcRectangles(),
		boundingRect = rectangles.length && rectangles.reduce((accumulator, current) => accumulator.wrap(current)),
		self = this;
	self.translate = (offset) => {
		return new RectSet({rectangles: rectangles.map(rect => rect.translate(offset))});
	};
	self.intersectionsOnRect = rect => {
		if (!rect || !rect.intersection(boundingRect)) {
			return new RectSet();
		}
		const result = [];
		rectangles.forEach(myRect => {
			const intersection = myRect.intersection(rect);
			if (intersection) {
				result.push(intersection);
			}
		});
		return new RectSet({rectangles: result});
	};
	self.hasIntersectionOnRect = rect => {
		if (!rect || !rect.intersection(boundingRect)) {
			return false;
		}
		return !!rectangles.find(myRect => myRect.intersection(rect));
	};
	self.intersectionsOnRectSet  = (rectSet) => {
		if (!rectSet || !rectSet.boundingRect || !boundingRect || !boundingRect.intersection(rectSet.boundingRect)) {
			return new RectSet();
		}
		const rectSets = rectangles.map(rect => rectSet.intersectionsOnRect(rect));
		return new RectSet({rectSets});
	};
	self.isEmpty = () => !rectangles.length;
	self.hasIntersectionsOnRectSet = rectSet => {
		if (!rectSet || !rectSet.boundingRect || !boundingRect || !boundingRect.intersection(rectSet.boundingRect)) {
			return false;
		}
		const result = !!rectangles.find(myRect => rectSet.hasIntersectionOnRect(myRect));
		return result;
	};
	Object.freeze(Object.assign(self, {rectangles, boundingRect}));
};
